export enum OrderType {
    Normal = 0,
    TakeAway = 1,
    Pickup = 2,
    OrderAtTheTable = 3,
    ShopDelivery = 4,
    Delivery = 5
}
